import {
    LOAD_APPLICATIONS,
    LOAD_APPLICATIONS_SUCCESS,
    CREATE_APPLICATION_REQUEST,
    SET_CREATE_APPLICATION_LOADING
} from './constants'

const initialState = {
    applicationList: [],
    loadingApplications: true,
    loadingCreateApplication: false
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        case LOAD_APPLICATIONS:
            return {
                ...state,
                loadingApplications: true
            }
        case LOAD_APPLICATIONS_SUCCESS:
            return {
                ...state,
                applicationList: payload.applications,
                loadingApplications: false
            }
        case CREATE_APPLICATION_REQUEST:
            return {
                ...state,
                loadingCreateApplication: true
            }
        case SET_CREATE_APPLICATION_LOADING:
            return {
                ...state,
                loadingCreateApplication: payload
            }
        default:
            return state
    }
}

export default reducer
